import { render, staticRenderFns } from "./ThemeFootballEffects.vue?vue&type=template&id=0590a2fb&"
import script from "./ThemeFootballEffects.vue?vue&type=script&lang=js&"
export * from "./ThemeFootballEffects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports